export default "__VITE_ASSET__8222d318__"